import { FC, memo, useMemo } from "react";
import { Box, Paper, useTheme, Theme, SxProps } from "@mui/material";
import { IRoadLayoutConfig, CarriageWayEnum } from "types";
import images from "./images";
import getStyles from "./styles";

type Props = {
  roadLayoutConfig: IRoadLayoutConfig;
  sx?: SxProps<Theme>;
};

const carriagewayImage = (roadLayout: IRoadLayoutConfig): string => {
  const isSingle = roadLayout.carriageWay === CarriageWayEnum.SINGLE;

  const { borderAreaLeft, borderAreaRight } = roadLayout;
  if (borderAreaLeft && borderAreaRight) return isSingle ? images.single.borderBoth : images.double.borderBoth;
  if (borderAreaLeft) return isSingle ? images.single.borderLeft : images.double.borderLeft;
  if (borderAreaRight) return isSingle ? images.single.borderRight : images.double.borderRight;

  return isSingle ? images.single.selected : images.double.selected;
};

const CarriagewayImage: FC<Props> = ({ roadLayoutConfig, sx = {} }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const imageSrc = useMemo(() => carriagewayImage(roadLayoutConfig), [roadLayoutConfig]);

  return (
    <Paper sx={{ ...styles.card, ...sx } as SxProps<Theme>} className="RlxCarriagewayImage">
      <Box component="img" src={imageSrc} sx={styles.img} />
    </Paper>
  );
};

CarriagewayImage.displayName = "CarriagewayImage";

export default memo(CarriagewayImage);
